import { createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from 'redux-thunk';
import authReducer from './reducers/authReducer';
import driverPartnerReducer from './reducers/driverPartnerReducer';
import notificationReducer from './reducers/notificationReducer';
import supportReducer from './reducers/supportReducer';
import driverReducer from './reducers/driverReducer';

// Combine reducers if there are multiple reducers
const rootReducer = combineReducers({
  auth: authReducer,
  driverPartner:driverPartnerReducer,
  notifications: notificationReducer,
  support: supportReducer,
  driver: driverReducer,


});


// Create Redux store with middleware
const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
